<template>
    <div class="companyAdd">
        <Breadcumb title="Ajouter une catégorie de forum" :breadcumb-data="breadcumbData"></Breadcumb>
        <b-card class="cardcontainer">
            <b-form @submit="categoryAdd">
                <b-form-group label="Nom" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <b-input type="text" placeholder="Nom" v-model="name" :state="errors['name'] ? 'invalid': ''"/>
                    <div v-if="errors['name']" role="alert" aria-live="polite" aria-atomic="true"
                         class="alert alert-dismissible alert-danger">
                        {{ errors['name'][0] }}
                    </div>
                </b-form-group>
                <b-form-group label="Ordre" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                    <b-input type="text" placeholder="Nom" v-model="order" :state="errors['order'] ? 'invalid': ''"/>
                    <div v-if="errors['order']" role="alert" aria-live="polite" aria-atomic="true"
                         class="alert alert-dismissible alert-danger">
                        {{ errors['order'][0] }}
                    </div>
                </b-form-group>
                <b-form-row>
                    <div class="col-md-10 ml-md-auto">
                        <b-btn type="submit" variant="primary">Ajouter une catégorie de forum</b-btn>
                    </div>
                </b-form-row>
            </b-form>
        </b-card>
    </div>
</template>
<script>
    import {
        ADD_CATEGORIES_REQUEST
    } from '../../_store/exchange/actiontypes'

    import { mapState } from 'vuex'
    import Breadcumb from '../../components/breadcumb'

    export default {
        name: 'companyAdd',
        components: { Breadcumb},
        mounted() {
        },
        computed: mapState({
            errors: state => state.company.errors,
            user: state => state.user.user
        }),
        data() {
            return ({
                breadcumbData: [
                    { text: 'Accueil', href: '/dashboard/' },
                    { text: 'Liste des catégorie de forum', href: '/company/' },
                    { text: 'Création d\'une catégorie de forum', active: true }
                ],
                name: ''
            })
        },
        layout(context) {
            return 'layout'
        },
        methods: {
            categoryAdd: function(e) {
                e.preventDefault();
                this.$store.dispatch(ADD_CATEGORIES_REQUEST, {
                    name: this.name,
                    order: this.order
                })
                    .then(() => {
                        this.$router.push('/dashboard/administration/companies/')
                    })
                    .catch((error) => {
                        console.log('error is ==');
                        console.log(error)
                    })
            }
        }
    }
</script>
